PegasusTemplate.BaseState = Ember.State.extend({
  unhandledEvent: function( /*manager, eventName*/ ) {
    //console.log("PegasusTemplate.StateMachine got an unhandledEvent with name " + eventName);
  },

  setup: function( manager, context ) {
    manager.set('context', context);
  },
  didSave: function(manager){
    PegasusTemplate.stateMachine.transitionTo('saved');
  },
  success: function(){
    PegasusTemplate.stateMachine.transitionTo('saved');
  },

  gotoValidating: function(manager){
    manager.transitionTo('validating.confirming');
  }

});
